<div id="top" class="header-text pt-lg-4 px-4 pt-2">
  <p class="text-center mb-0">
    Program Matcher
  </p>
  <small>Tell us about yourself and we’ll help you find schools and programs that are
      matches to you.</small>
</div>
<form name="Loginform" (ngSubmit)="f.form.valid && loginsubmit()" #f="ngForm" novalidate>
<div class="wrapper   {{formClass}}">
  <div class="modal-header">
     <h2 class="sub-header-text">Login</h2>
  </div>
  <div class="modal-body">
     <div class="form-group">
        <label for="username" class="ques-text"> <i class="fa fa-user"></i> Username</label>
        <input id="username-text" name="username" type="text" [(ngModel)]="login.uname" class="form-control" required placeholder="Username">
     </div>
     <div class="form-group ">
        <label for="password" class="ques-text"> <i class="fa fa-lock"></i> Password</label>
        <input id="password-text" name="password" type="password" [(ngModel)]="login.password" class="form-control" required placeholder="Password">
     </div>
     <p class="text-center mb-0">
        <small >
            We respect your privacy and will NOT sell your data to any third-parties.
         </small>
     </p>
     <p class="text-center mt-3 mb-0"><a href="javascript:void(0)" (click)="searchData()" class="btn btn-search"><i class="fa fa-search"></i> Search Data</a></p>
     <div class="error-display" *ngIf="errdisplay">
      <ul class="p-0"><li *ngFor='let msg of errormsg' class="errorclass">{{ msg }}</li></ul>
    </div>
  </div>
  <div class="modal-footer m-footer justify-content-end">
      <a href="javascript:void(0)" (click)="clickSubmit(f.form.valid)" class="btn btn-next btn-xs">
          Submit &nbsp; <i class="fas fa-arrow-right"></i>
      </a>
  </div>
</div>
</form>


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/login/login.component.html